import { AssociateArray, Form } from '~/shared/api'
import { Attachment } from '~/interfaces/Calendars'

export default class CalendarSlotForm extends Form {
  protected attachments: AssociateArray<Attachment> = new AssociateArray()

  constructor(protected calendarId: string, protected start: string, protected end: string) {
    super()
  }

  addAttachment(value: Attachment) {
    this.attachments.push(value)
  }
}
